const rows = [
  { platform: 'Android', device: '安卓手机 / 平板', version: 'Android 6.0 及以上', highlight: false },
  { platform: 'iOS', device: 'iPhone / iPad', version: 'iOS 12.0 及以上', highlight: true },
  { platform: 'HarmonyOS', device: '鸿蒙手机 / 平板', version: 'HarmonyOS 2.0 及以上', highlight: false },
  { platform: 'TV 版', device: '智能电视 / 电视盒子', version: 'Android 5.0 及以上', highlight: true },
];

export default function GuaziDeviceSupport() {
  return (
    <section className="w-full bg-background-50 px-4 md:px-6 py-16 md:py-24">
      <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
        <div className="w-full lg:w-[40%] flex justify-center">
          <img
            src="/images/guazi-mascot-2.png"
            alt="瓜子影视吉祥物"
            title="瓜子影视APP下载官网"
            className="w-[240px] md:w-[340px] guazi-float"
          />
        </div>

        <div className="w-full lg:w-[60%]">
          <span className="inline-flex items-center gap-2 px-3 py-1.5 bg-secondary-100 text-secondary-700 rounded-full text-xs md:text-sm font-bold">
            <i className="ri-device-line text-base" />
            机型支持
          </span>
          <h2 className="mt-4 font-heading font-extrabold text-3xl md:text-4xl text-foreground-950">
            多设备全覆盖
          </h2>
          <p className="mt-4 text-sm md:text-base text-foreground-600 leading-7">
            无论你使用手机、平板还是电视，都可以通过瓜子影视APP下载官网找到合适的版本，享受一致的观影体验。
          </p>

          <div className="mt-7 overflow-hidden rounded-lg border border-background-200">
            <div className="grid grid-cols-3 bg-background-100">
              <div className="px-4 py-3 text-xs md:text-sm font-bold text-foreground-800">平台</div>
              <div className="px-4 py-3 text-xs md:text-sm font-bold text-foreground-800">适用设备</div>
              <div className="px-4 py-3 text-xs md:text-sm font-bold text-foreground-800">系统要求</div>
            </div>
            {rows.map((row) => (
              <div
                key={row.platform}
                className={`grid grid-cols-3 border-t border-background-200 ${row.highlight ? 'bg-accent-50' : 'bg-background-50'}`}
              >
                <div className="px-4 py-3.5 text-xs md:text-sm font-bold text-primary-700">{row.platform}</div>
                <div className="px-4 py-3.5 text-xs md:text-sm text-foreground-700">{row.device}</div>
                <div className="px-4 py-3.5 text-xs md:text-sm text-foreground-600">{row.version}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}